import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=124e624b&scoped=true"
import script from "./LeadsTable.vue?vue&type=script&lang=ts"
export * from "./LeadsTable.vue?vue&type=script&lang=ts"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=124e624b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e624b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124e624b')) {
      api.createRecord('124e624b', component.options)
    } else {
      api.reload('124e624b', component.options)
    }
    module.hot.accept("./LeadsTable.vue?vue&type=template&id=124e624b&scoped=true", function () {
      api.rerender('124e624b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/LeadsTable.vue"
export default component.exports